import React from "react";
import styled from "styled-components";
import Container from "../../Components/Container";
import Typewriter from "typewriter-effect";
import ButtonTestFree from "../../Components/ButtonTestFree";

const Title = styled.h1`
  font-weight: 300;
  font-size: 65px;
  color: #fff;
  min-height: 450px; 
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin: 0 auto;

  @media (max-width: 768px) {
    font-size: 40px;
    min-height: 300px;
  }
`;

const SpanText = styled.span`
  font-weight: 200;
  font-size: 20px;
  line-height: 30px;
  color: #fff;

  @media (max-width: 768px) {
    font-size: 16px;
    line-height: 24px;
  }
`;

const Home = () => {
  return (
    <Container style={{ textAlign: "center", paddingBottom: '80px', paddingTop: '120px' }} id="section-1">
      <Title>
        <Typewriter
          onInit={(typewriter) => {
            typewriter
              .typeString(
                `Seu cliente não espera. <br/> O <span style="color:#E4DA1B;">Alfred</span> também não.`
              ).start();
          }}
          options={{
            autoStart: true,
            loop: false,
            delay: 50,
          }}
        />
      </Title>
      <SpanText>
        Enquanto você trabalha, o Alfred responde seus clientes no <br />
        <span style={{ fontWeight: "bold" }}>WhatsApp</span> automaticamente.
      </SpanText>
      <ButtonTestFree />
      <SpanText style={{fontSize: '15px'}}>
        <span style={{ fontWeight: 400 }}>Sem cartão de crédito. Configuração em minutos</span>
      </SpanText>
    </Container>
  );
};

export default Home;
